export const dateRangeConst = [
  {
    title: "Date Range",
    field: "date_range",
    type: "select",
    defaultValue: "TODAY",
    options: [
      { label: "Today", value: "TODAY" },
      { label: "Days Back", value: "DB" },
      { label: "Months Back", value: "MB" },
      { label: "Fiscal Quarters", value: "FQ" },
      { label: "Month to Date", value: "MTD" },
      { label: "Year to Date", value: "YTD" },
      { label: "Month to Date( Last Year )", value: "WTDLY" },
      { label: "Year to Date ( Last Year )", value: "MTDLY" },
      { label: "Fixed Period", value: "FP" },
      { label: "Relative Fixed Period", value: "RFP" },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "TODAY",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "TODAY",
      },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "MTD",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "MTD",
      },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "YTD",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "YTD",
      },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "WTDLY",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "WTDLY",
      },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "MTDLY",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "number",
    defaultValue: "",
    display: "hidden",
    dependsOn: [
      {
        field: "date_range",
        value: "MTDLY",
      },
    ],
  },
  {
    title: "Start Date",
    field: "arg1",
    type: "date",
    defaultValue: "2021-10-10",
    dependsOn: [
      {
        field: "date_range",
        value: "FP",
      },
    ],
  },
  {
    title: "End Date",
    field: "arg2",
    type: "date",
    defaultValue: "2023-10-10",
    dependsOn: [
      {
        field: "date_range",
        value: "FP",
      },
    ],
  },
  {
    title: "Days Back",
    field: "arg1",
    type: "number",
    defaultValue: 30,
    dependsOn: [
      {
        field: "date_range",
        value: "DB",
      },
    ],
  },
  {
    title: "Number of Days",
    field: "arg2",
    type: "number",
    defaultValue: 30,
    dependsOn: [
      {
        field: "date_range",
        value: "DB",
      },
    ],
  },
  {
    title: "Months Back",
    field: "arg1",
    type: "number",
    defaultValue: 1,
    dependsOn: [
      {
        field: "date_range",
        value: "MB",
      },
    ],
  },
  {
    title: "Number of Months",
    field: "arg2",
    type: "number",
    defaultValue: 1,
    dependsOn: [
      {
        field: "date_range",
        value: "MB",
      },
    ],
  },
  {
    title: "Fiscal First Month",
    field: "arg1",
    type: "select",
    defaultValue: 1,
    options: [
      { label: "January", value: 1 },
      { label: "February", value: 2 },
      { label: "March", value: 3 },
      { label: "April", value: 4 },
      { label: "May", value: 5 },
      { label: "June", value: 6 },
      { label: "July", value: 7 },
      { label: "August", value: 8 },
      { label: "September", value: 9 },
      { label: "October", value: 10 },
      { label: "November", value: 11 },
      { label: "December", value: 12 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "FQ",
      },
    ],
  },
  {
    title: "Period",
    field: "arg2",
    type: "select",
    defaultValue: 1,
    options: [
      { label: "Q1", value: 1 },
      { label: "Q2", value: 2 },
      { label: "Q3", value: 3 },
      { label: "Q4", value: 4 },
      { label: "Q1+Q2", value: 5 },
      { label: "Q3+Q4", value: 6 },
      { label: "Q1+Q2+Q3", value: 7 },
      { label: "Q2+Q3+Q4", value: 8 },
      { label: "Full Year", value: 9 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "FQ",
      },
    ],
  },
  {
    title: "Year",
    field: "arg3",
    type: "select",
    defaultValue: 1,
    options: [
      { label: "Current Year", value: 1 },
      { label: "Last Year", value: 2 },
      { label: "Year Before Last", value: 3 },
      { label: "3 Years Back", value: 4 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "FQ",
      },
    ],
  },
  {
    title: "Start Day",
    field: "arg1",
    type: "select",
    defaultValue: 19,
    options: [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5", value: 5 },
      { label: "6", value: 6 },
      { label: "7", value: 7 },
      { label: "8", value: 8 },
      { label: "9", value: 9 },
      { label: "10", value: 10 },
      { label: "11", value: 11 },
      { label: "12", value: 12 },
      { label: "13", value: 13 },
      { label: "14", value: 14 },
      { label: "15", value: 15 },
      { label: "16", value: 16 },
      { label: "17", value: 17 },
      { label: "18", value: 18 },
      { label: "19", value: 19 },
      { label: "20", value: 20 },
      { label: "21", value: 21 },
      { label: "22", value: 22 },
      { label: "23", value: 23 },
      { label: "24", value: 24 },
      { label: "25", value: 25 },
      { label: "26", value: 26 },
      { label: "27", value: 27 },
      { label: "28", value: 28 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "RFP",
      },
    ],
  },
  {
    title: "End Day",
    field: "arg2",
    type: "select",
    defaultValue: 18,
    options: [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5", value: 5 },
      { label: "6", value: 6 },
      { label: "7", value: 7 },
      { label: "8", value: 8 },
      { label: "9", value: 9 },
      { label: "10", value: 10 },
      { label: "11", value: 11 },
      { label: "12", value: 12 },
      { label: "13", value: 13 },
      { label: "14", value: 14 },
      { label: "15", value: 15 },
      { label: "16", value: 16 },
      { label: "17", value: 17 },
      { label: "18", value: 18 },
      { label: "19", value: 19 },
      { label: "20", value: 20 },
      { label: "21", value: 21 },
      { label: "22", value: 22 },
      { label: "23", value: 23 },
      { label: "24", value: 24 },
      { label: "25", value: 25 },
      { label: "26", value: 26 },
      { label: "27", value: 27 },
      { label: "28", value: 28 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "RFP",
      },
    ],
  },
  {
    title: "Month Back",
    field: "arg3",
    type: "select",
    defaultValue: 1,
    options: [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5", value: 5 },
      { label: "6", value: 6 },
      { label: "7", value: 7 },
      { label: "8", value: 8 },
      { label: "9", value: 9 },
      { label: "10", value: 10 },
      { label: "11", value: 11 },
      { label: "12", value: 12 },
      { label: "13", value: 13 },
      { label: "14", value: 14 },
      { label: "15", value: 15 },
      { label: "16", value: 16 },
      { label: "17", value: 17 },
      { label: "18", value: 18 },
      { label: "19", value: 19 },
      { label: "20", value: 20 },
      { label: "21", value: 21 },
      { label: "22", value: 22 },
      { label: "23", value: 23 },
      { label: "24", value: 24 },
    ],
    dependsOn: [
      {
        field: "date_range",
        value: "RFP",
      },
    ],
  },
];
export const chooseReportLabelListRND = [
  {
    value: "get_lender_loans_report_v2_detail",
    label: "Loan Account List v2 - Detail",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
    ],
  },
  {
    value: "report_p_and_i_transactions",
    label: "P and I Transaction Report v2",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "get_lender_loans_report_v2",
    label: "Loan Account List v2",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
    ],
  },
  {
    value: "report_lender_servicing_activity_summary2",
    label: "Lender-Loan Daily Activity Summary v2",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_servicing_activity_summary",
    label: "Lender-Loan Daily Activity Summary",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "draws_transactions_report",
    label: "Draws Transactions Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_distribution_remittance_detail2",
    label: "Lender Distribution Remittance Detail Report V2",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Include Pending",
        field: "include_pending",
        type: "radio",
        options: [
          { title: "No", value: 0 },
          { title: "Yes", value: 1 },
        ],
      },
    ],
  },
  {
    value: "report_p_and_i_transactions",
    label: "P & I Transaction Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_Lender_Borrower_Payment_Activity_Remitt_Report",
    label: "Borrower Payment Activity Remitt Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_Loan_Maturity",
    label: "Loan Maturity Report",
    options: [
      {
        title: "Lenders Account",
        field: "LendersAccount",
        type: "lenderSelect",
      },
      {
        title: "Days Till Maturity",
        field: "DaysTillMaturity",
        type: "date",
        defaultValue: "2021-10-10",
      },
      {
        title: "Sort By",
        field: "SortBy",
        type: "select",
        options: [
          { label: "A", value: "A" },
          { label: "D", value: "D" },
        ],
      },
    ],
  },
  {
    value: "report_getACHInfo",
    label: "ACH Deposit Notification Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_loan_history",
    label: "Loan History",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_borrower_paystring2",
    label: "Borrower DQ Status - PayString Report",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
      { title: "Months Back", field: "monthsback", type: "number" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
  {
    value: "report_lender_distribution_remittance_detail",
    label: "Lender Distribution Remittance Detail Report",
    options: [
      {
        title: "Check Number",
        field: "check_number",
        type: "text",
        display: "hidden",
      },
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Include Pending",
        field: "include_pending",
        type: "radio",
        options: [
          { title: "No", value: 0 },
          { title: "Yes", value: 1 },
        ],
      },
    ],
  },
  {
    value: "report_borrower_payment_distribution_audit",
    label: "Borrower Payment Distribution Audit Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
  {
    value: "report_borrower_delinquency_report",
    label: "Borrower Delinquency Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },

  {
    value: "report_Daily_Activity2",
    label: "Lender-Loan Daily Activity History",
    options: [
      { title: "Exclude Advances", field: "exclude_advances", type: "Number" },
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_Daily_Activity",
    label: "Advanced Date Filter Test 4",
    options: [
      { title: "Start Date", field: "startdate", type: "date" },
      { title: "End Date", field: "enddate", type: "date" },
      { title: "Exclude Advances", field: "exclude_advances", type: "Number" },
    ],
  },
  {
    value: "report_borrower_late_report2",
    label: "Borrower Late Report",
    options: [
      {
        title: "Exclude Borrowers On Hold",
        field: "excludeOnHold",
        type: "radio",
        options: [
          { title: "Yes", value: 0 },
          { title: "No", value: 1 },
        ],
      },
      {
        title: "Exclude Loans Within Grace Period",
        field: "excludeWithinGracePeriod",
        type: "radio",
        options: [
          { title: "Yes", value: 0 },
          { title: "No", value: 1 },
        ],
      },
    ],
  },
  {
    value: "report_wells_fargo",
    label: "Lender-Servicing Activity Summary",
    options: [
      { title: "Start Day", field: "startday", type: "number" },
      { title: "End Day", field: "endday", type: "number" },
      { title: "Months Back", field: "months_back", type: "Number" },
    ],
  },
  {
    value: "get_lender_loans_report",
    label: "Loan Account List",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
    ],
  },
  {
    value: "get_past_payments3",
    label: "Lender Past Payments",
    options: [],
  },
  {
    value: "report_loan_portfolio",
    label: "Portfolio Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_statement",
    label: "Lender Statement of Account",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_loan_statement_details3",
    label: "Lender Loan Data - Weston Schema 202207",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      { title: "Category", field: "Category", type: "text" },
    ],
  },
  {
    value: "report_borrower_payment_summary",
    label: "Borrower Payment Summary Report",
    options: [
      ...dateRangeConst,
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
];
export const reportGridColumn2RND = [
  {
    field: "Lender Account",
    title: "Loan Acc",
  },
  {
    field: "Original Balance",
    title: "Original Balance",
  },
  {
    field: "Current Balance",
    title: "Current Balance",
  },
  {
    field: "Loan Info",
    title: "Loan Info",
  },
  {
    field: "Next Due Dates",
    title: "Next Due Dates",
  },
  {
    field: "Lender Principal Investment",
    title: "Lender Principal Investment",
  },
  {
    field: "YTD Interest",
    title: "YTD Interest",
  },
  {
    field: "Time to Maturit",
    title: "Time to Maturit",
  },
  {
    field: "Term Left",
    title: "Term Left",
  },
  {
    field: "Maturity Date",
    title: "Maturity Date",
  },
  {
    field: "PStreet",
    title: "PStreet",
  },
  {
    field: "Pcity",
    title: "Pcity",
  },
  {
    field: "Pstate",
    title: "Pstate",
  },
  {
    field: "Pzipcode",
    title: "Pzipcode",
  },
  {
    field: "Property Address",
    title: "Property Address",
  },
  {
    field: "Borrower Name",
    title: "Borrower Name",
  },
  {
    field: "Days Late",
    title: "Days Late",
  },
  {
    field: "noterate",
    title: "Noterate",
  },
  {
    field: "soldrate",
    title: "Soldrate",
  },
];
export const intialStateRND = {
  past: 0,
  min: 1000,
  max: 10000000,
  minimum: 1000,
  maximum: 10000000,
  monthsback: 0,
  borrower_account_min: "",
  borrower_account_max: "",
  date_range: "",
  arg1: "",
  arg2: "",
  arg3: "",
  check_number: "",
  include_pending: 0,
  lenderId: 0,
  exclude_advances: 0,
  startdate: 0,
  enddate: 0,
  excludeOnHold: 0,
  excludeWithinGracePeriod: 0,
  startday: 1,
  endday: 1,
  months_back: 1,
  monthsback: 1,
  Category: 0,
};
